"use client";
import { useEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";
import styles from "./OverlayPortal.module.css";
import classNames from "classnames";
import CloseSvg from "src/components/svg/CloseSvg";
import { type CSSProperties } from "react";

//#region [Props]
type OverlayPortalProps = {
    className?: string;
    style?: CSSProperties
    children?: ReactNode;
    doClose: () => void;
    hideClose?: boolean;
};
//#endregion

//#region [Component]
export default function OverlayPortal({ className, children, doClose, hideClose = false, style }: OverlayPortalProps) {
    useEffect(() => {
        document.body.classList.add("noscroll");
        return () => {
            document.body.classList.remove("noscroll");
        }
    }, []);
    return createPortal(<div className={classNames(styles.OverlayPortal, className)} style={style}>
        {!hideClose && <button onClick={doClose} className={styles.CloseButton}><CloseSvg /></button>}
        {children}
    </div>, document.body);
}
//#endregion
